import React, { useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import img from "../assets/img/220880-P1KV8M-746.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllCities } from "../actions/cityActions";
import { getAllCategories } from "../actions/categories";
import { getAllSubCategories } from "../actions/subCategories";
import { getAllCustomers, getAllDrivers } from "../actions/userActions";
const AdminDashboard = () => {
  const auth = useSelector((x) => x.auth);

  const dispatch = useDispatch();
  const citiesData = async (e) => {
    dispatch(getAllCities({}));
  };
  const customersData = async (e) => {
    dispatch(getAllCustomers({}));
  };
  const driversData = async (e) => {
    dispatch(getAllDrivers({}));
  };
  const cateData = async (e) => {
    dispatch(getAllCategories({}));
  };
  // useEffect(() => {
  //   citiesData();
  // }, []);
  // useEffect(() => {
  //   cateData();
  // }, []);
  const subCateData = async (e) => {
    dispatch(getAllSubCategories({}));
  };
  useEffect(() => {
    subCateData();
    cateData();
    citiesData();
    customersData();
    driversData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card rounded-1">
                  <div className="card-body p-2">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-info rounded-1">
                        <i className="fas fa-cart-plus"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Orders</div>
                        <div className="dash-counts">
                          <p>3138</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card rounded-1">
                  <div className="card-body p-2">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-primary rounded-1">
                        <i className="fas fa-users"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Users</div>
                        <div className="dash-counts">
                          <p>2689</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card rounded-1">
                  <div className="card-body p-2">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-warning rounded-1">
                        <i className="fas fa-store"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Shops</div>
                        <div className="dash-counts">
                          <p>20</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card rounded-1">
                  <div className="card-body p-2">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-info rounded-1">
                        <i className="fas fa-cubes"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Products</div>
                        <div className="dash-counts">
                          <p>834</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card flex-fill rounded-1">
                  <div className="card-body">
                    <h5 className="card-title">Today Orders Stats</h5>
                    <p className="card-subtitle mb-3 text-muted">26 December</p>
                    <canvas id="todayChart"></canvas>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card flex-fill rounded-1">
                  <div className="card-body">
                    <h5 className="card-title">Weekly Orders Stats</h5>
                    <p className="card-subtitle mb-3 text-muted">
                      23-29 December
                    </p>
                    <canvas id="weeklyChart"></canvas>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 d-flex">
                <div className="card flex-fill rounded-1">
                  <div className="card-body">
                    <h5 className="card-title">Monthly Orders Stats</h5>
                    <p className="card-subtitle mb-3 text-muted">
                      01-31 December
                    </p>
                    <canvas id="monthlyChart"></canvas>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Recent Orders</h5>
                      </div>
                      <div className="col-auto">
                        <a
                          href="#"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>Username</th>
                            <th>Store</th>
                            <th>Date</th>
                            <th>Total</th>
                            <th>Order To</th>
                            <th className="text-right">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>John Doe</td>
                            <td>Store 1</td>
                            <td>26 Dec 2024</td>
                            <td>$129.00</td>
                            <td>Home</td>
                            <td className="text-right">
                              <button className="btn btn-sm btn-primary mx-1">
                                View
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>John Doe</td>
                            <td>Store 2</td>
                            <td>26 Dec 2024</td>
                            <td>$129.00</td>
                            <td>Home</td>
                            <td className="text-right">
                              <button className="btn btn-sm btn-primary mx-1">
                                View
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>John Doe</td>
                            <td>Store 1</td>
                            <td>26 Dec 2024</td>
                            <td>$129.00</td>
                            <td>Home</td>
                            <td className="text-right">
                              <button className="btn btn-sm btn-primary mx-1">
                                View
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>John Doe</td>
                            <td>Store 1</td>
                            <td>26 Dec 2024</td>
                            <td>$129.00</td>
                            <td>Home</td>
                            <td className="text-right">
                              <button className="btn btn-sm btn-primary mx-1">
                                View
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>John Doe</td>
                            <td>Store 1</td>
                            <td>26 Dec 2024</td>
                            <td>$129.00</td>
                            <td>Home</td>
                            <td className="text-right">
                              <button className="btn btn-sm btn-primary mx-1">
                                View
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-sm-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Recent Customers</h5>
                      </div>
                      <div className="col-auto">
                        <a
                          href="#"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Cover</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src="assets/img/profiles/avatar-01.jpg"
                                alt="User"
                                className="rounded border"
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>John Doe</td>
                            <td>9876543210</td>
                            <td>Johndeo@gmail.com</td>
                            <td>
                              <div className="btn-gorup">
                                <button className="btn btn-sm btn-success">
                                  Active
                                </button>
                                <button className="btn btn-sm btn-primary mx-1">
                                  View
                                </button>
                                <button className="btn btn-sm btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/profiles/avatar-02.jpg"
                                alt="User"
                                className="rounded border"
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>Muhammad Talha</td>
                            <td>9876543210</td>
                            <td>muhammadtalha@gmail.com</td>
                            <td>
                              <div className="btn-gorup">
                                <button className="btn btn-sm btn-success">
                                  Active
                                </button>
                                <button className="btn btn-sm btn-primary mx-1">
                                  View
                                </button>
                                <button className="btn btn-sm btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/profiles/avatar-03.jpg"
                                alt="User"
                                className="rounded border"
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>John Doe</td>
                            <td>9876543210</td>
                            <td>Johndeo@gmail.com</td>
                            <td>
                              <div className="btn-gorup">
                                <button className="btn btn-sm btn-success">
                                  Active
                                </button>
                                <button className="btn btn-sm btn-primary mx-1">
                                  View
                                </button>
                                <button className="btn btn-sm btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/profiles/avatar-04.jpg"
                                alt="User"
                                className="rounded border"
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>John Doe</td>
                            <td>9876543210</td>
                            <td>Johndeo@gmail.com</td>
                            <td>
                              <div className="btn-gorup">
                                <button className="btn btn-sm btn-success">
                                  Active
                                </button>
                                <button className="btn btn-sm btn-primary mx-1">
                                  View
                                </button>
                                <button className="btn btn-sm btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/profiles/avatar-05.jpg"
                                alt="User"
                                className="rounded border"
                                width="40"
                                height="40"
                              />
                            </td>
                            <td>John Doe</td>
                            <td>9876543210</td>
                            <td>Johndeo@gmail.com</td>
                            <td>
                              <div className="btn-gorup">
                                <button className="btn btn-sm btn-success">
                                  Active
                                </button>
                                <button className="btn btn-sm btn-primary mx-1">
                                  View
                                </button>
                                <button className="btn btn-sm btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-md-12 col-sm-12"></div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "90px",
            }}
          >
            <img src={img} alt="" style={{ height: "380px" }} />
            <p
              style={{
                alignContent: "center",
                paddingLeft: "20px",
                fontSize: "20px",
              }}
            >
              Under Progress
            </p>
          </div>
        </div> */}
      </div>
    </>
  );
};
export default AdminDashboard;
